import { message } from 'antd'
import { useState, useEffect } from 'react'
import useBillTypeContext from './useStockBillTypeContext'
import * as Utils from '../../../@utils'
import { inventoryTypeMap } from '../config'

export default function useBatchOperateSelectedItem(pageData) {
  const [selectedItems, setSelectedItems] = useState([])
  const { baseQueryModule, type } = useBillTypeContext()
  const exportSelectedItems = async () => {
    if (selectedItems && selectedItems.length > 0) {
      let res = await baseQueryModule.exportStockSheet(selectedItems)
      let fileName = `${inventoryTypeMap[type]}单${Utils.parseTime(
        Date.parse(new Date())
      )}.xlsx`
      Utils.download(res, fileName)
    } else {
      message.info('请选择单据')
    }
  }
  useEffect(() => {
    setSelectedItems([])
  }, [pageData])
  return {
    exportSelectedItems,
    setSelectedItems,
    selectedRowKeys: selectedItems
  }
}
